import { action, makeObservable, observable, runInAction } from 'mobx';
import { createCompany, getCompany } from '../api/admin';
import { IS_STAGING } from '../environment';
import Company from '../model/Company';
import CreateCompanyDto from '../model/CreateCompanyDto';

class CompanyStore {
  companyKey?: string;

  data: Company | null = null;

  loading = false;

  createCompanyError = '';

  constructor() {
    makeObservable(this, {
      companyKey: observable,
      loading: observable,
      data: observable,
      setCompany: action,
      loadCompany: action,
    });
  }

  setCompany(companyKey: string) {
    if (companyKey === this.companyKey) return;
    this.companyKey = companyKey;
    this.data = null;
    this.loadCompany(companyKey);
  }

  loadCompany(companyKey: string) {
    this.loading = true;
    getCompany(companyKey).then((res) => {
      runInAction(() => {
        this.data = { ...res, id: companyKey };
        this.loading = false;
      });
    });
  }

  createCompany = async (company: CreateCompanyDto): Promise<Company | void> => {
    if (company) {
      return createCompany(company)
        .then((newCompany) => {
          runInAction(() => {
            this.createCompanyError = '';
          });
          return newCompany;
        })
        .catch((err) => {
          runInAction(() => {
            this.createCompanyError = err.name;
          });
        });
    }
    throw new Error('No company data provided');
  };

  setCreateCompanyError = (error: string): void => {
    this.createCompanyError = error;
  };

  firestoreLink() {
    return IS_STAGING
      ? `https://console.firebase.google.com/u/0/project/enklakassan-staging/firestore/data/~2Fcompanies~2F${this.companyKey}`
      : `https://console.firebase.google.com/u/0/project/enkla-kassan/firestore/data/~2Fcompanies~2F${this.companyKey}`;
  }
}
export default CompanyStore;
